class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHover();
  }

  /*
    ============================================================
    فتح القائمة الفرعية بالهوفر على الديسكتوب

    <details> بطبيعته بيفتح بالضغط بس — مفيش أي دعم للهوفر في
    Dawn. فالزائر بيقف على عنصر فيه سهم لتحت ومفيش حاجة بتحصل.

    الشروط اللي الحركة دي بتشتغل تحتها، وكل واحد ليه سبب:

      hover: hover + pointer: fine
        على اللمس المتصفح بيزوّد hover وهمي بعد أول لمسة، فأول
        ضغطة كانت هتفتح وتقفل مع بعض. الشرطين بيستثنوا اللمس.

      min-width: 990px
        القايمة دي أصلاً مخفية تحت المقاس ده.

    والقفل فيه تأخير بسيط عن قصد: الطريق من العنصر للقائمة اللي
    تحته بيعدّي على فراغ صغير، ومن غير التأخير القائمة كانت
    بتتقفل في نص الطريق.
    ============================================================
  */
  setupHover() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (this.dataset.hoverOpen === 'false') return;

    this.desktop = window.matchMedia('(min-width: 990px)');
    this.closeTimer = null;

    this.addEventListener('mouseenter', () => {
      if (!this.desktop.matches) return;
      clearTimeout(this.closeTimer);
      this.mainDetailsToggle.open = true;
      this.setDropOffset();
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    });

    this.addEventListener('mouseleave', () => {
      if (!this.desktop.matches) return;
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        // لو المستخدم مشى بالكيبورد لعنصر جوه القائمة، مبنقفلهاش
        if (!this.contains(document.activeElement)) this.close();
      }, 180);
    });
  }

  /*
    ============================================================
    المسافة من نهاية العنصر لنهاية الهيدر

    القائمة المنسدلة `absolute` جوه <details> اللي هو `relative`،
    فبتبدأ تحت الـ summary على طول — يعني **جوّه** الهيدر، لأن
    الهيدر تحت الـ summary فيه حشو كمان.

    المسافة دي مش رقم ثابت نكتبه في CSS: بتفرق مع ارتفاع الهيدر،
    ومع شريط الإعلانات، ومع حالة الاستيكي وقت السكرول. فبتتقاس
    **لحظة الفتح** — الوقت الوحيد اللي القيمة فيه أكيدة.
    ============================================================
  */
  setDropOffset() {
    if (!this.header || !this.mainDetailsToggle.open) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) return;
    const gap = this.header.getBoundingClientRect().bottom - summary.getBoundingClientRect().bottom;
    this.style.setProperty('--hm-drop-offset', `${Math.max(0, Math.round(gap))}px`);
  }

  onToggle() {
    this.setDropOffset();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
